
export enum TimeframeKeys {
  FIFTEEN_MIN = '15m',
  ONE_HOUR = '1h',
  SIX_HOUR = '6h',
  TWELVE_HOUR = '12h',
  ONE_DAY = '24h',
  SEVEN_DAY = '7d',
  THIRTY_DAY = '30d',
  NINETY_DAY = '90d',
  ONE_HUNDRED_EIGHTY_DAY = '180d',
  ONE_YEAR = '365d',
  CURRENT_WEEK = 'current_week',
  CURRENT_MONTH = 'current_month',
  CURRENT_QUARTER = 'current_quarter',
  CURRENT_YEAR = 'current_year',
  PREVIOUS_WEEK = 'previous_week',
  PREVIOUS_MONTH = 'previous_month',
  PREVIOUS_QUARTER = 'previous_quarter',
  PREVIOUS_YEAR = 'previous_year',
}
